module.exports = __webpack_public_path__ + "img/Intermediate.8b60d3bc.png";